import { LoadableComponent } from 'common/components';
import { withCleanOidcQueryParams } from 'core/auth/withCleanOidcQueryParmas.hoc';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppSettingsGuardComponent } from './app-settings-guard';
import { LayoutMainComponent } from './app.layout.style';
import { AppHeadComponent } from './head/app.head';
import { AppHeaderComponent } from './header/app.header';
import { AppScreenSizeGuard } from './screen-size-guard';

const AppLayoutBase: React.FC = () => (
  <>
    <AppHeadComponent />
    <React.Suspense fallback={null}>
      <AppHeaderComponent />
    </React.Suspense>
    <LayoutMainComponent>
      <AppScreenSizeGuard>
        <AppSettingsGuardComponent>
          <React.Suspense fallback={<LoadableComponent isLoading={true} />}>
            <Outlet />
          </React.Suspense>
        </AppSettingsGuardComponent>
      </AppScreenSizeGuard>
    </LayoutMainComponent>
  </>
);

export const AppLayout = withCleanOidcQueryParams(AppLayoutBase);
